import VueRouter from 'vue-router';


export function vueRouterPlugin(Vue) {
  Vue.use(VueRouter);
}
